<template>
  <div class="c-filter">
    <div class="c-btn"></div>
    <div class="c-form">
      <ElForm label-width="50" inline class="elementui-common-form-styles" v-highlight>
        <ElFormItem label="按钮下载类型" label-width="90">
          <ElSelect v-model="urlType" style="width: 90px" clearable @change="sendEvent">
            <ElOption :value="1" label="单端自动生成"></ElOption>
            <ElOption :value="2" label="双端手动填写"></ElOption>
          </ElSelect>
        </ElFormItem>
        <ElFormItem label="游戏组">
          <ElSelect v-model="groupId" placeholder="全部" filterable clearable @change="sendEvent">
            <ElOption v-for="item in GAME_GROUPS" :key="item.id" :label="item.name" :value="item.id"> </ElOption>
          </ElSelect>
        </ElFormItem>
        <ElFormItem label="游戏">
          <ElSelect v-model="gameId" placeholder="全部" filterable clearable @change="sendEvent">
            <ElOption v-for="item in GAMES" :key="item.id" :label="item.name" :value="item.id"> </ElOption>
          </ElSelect>
        </ElFormItem>
        <ElFormItem label="创建人">
          <ElSelect v-model="agentId" placeholder="全部" filterable clearable @change="sendEvent" style="width: 120px">
            <ElOption v-for="item in PTOM_USERS" :key="item.id" :label="item.name" :value="item.id"> </ElOption>
          </ElSelect>
        </ElFormItem>
        <ElFormItem label-width="0">
          <ElInput v-model.trim="keyword" :placeholder="placeholder" clearable @clear="search" @keyup.enter.native="search">
            <i slot="append" @click="search" class="el-icon-search"></i>
          </ElInput>
        </ElFormItem>

        <ElFormItem label-width="0" class="bg-transparent">
          <ElButton type="primary" @click="open">新建落地页</ElButton>
        </ElFormItem>
      </ElForm>
    </div>
  </div>
</template>
<script>
import { initPageData, GAME_GROUPS, GAMES, PTOM_USERS } from '@/data/global-opts'
// 当前页面需要的下拉数据项
const PAGE_REQUIRED_OPTS = initPageData([GAME_GROUPS, GAMES, PTOM_USERS])

export default {
  name: 'landFilter',
  props: {
    placeholder: {
      type: String
    }
  },
  computed: {
    ...PAGE_REQUIRED_OPTS
  },
  created() {
    this.sendEvent()
  },
  methods: {
    buildParams() {
      return {
        gameGroupId: this.groupId || undefined,
        gameId: this.gameId || undefined,
        urlType: this.urlType || undefined,
        uploadOpId: this.agentId || undefined,
        keyword: this.keyword || undefined
      }
    },
    sendEvent() {
      this.$emit('on-change', this.buildParams())
    },
    search() {
      this.$emit('on-search', this.buildParams())
    },

    open() {
      window.open('/pageland/pagelayout', '_blank')
    }
  },
  data() {
    return {
      keyword: '',
      urlType: '',
      groupId: '',
      gameId: '',
      agentId: ''
    }
  }
}
</script>
